import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import FlightSelection from "../components/FlightSelection/FlightSelection";
import PassengerSelection from "../components/PassengerSelection/PassengerSelection";
import SSROutlet from "../SSROutlet";
import SSRSelection from "../components/SSRSelection/SSRSelection";
import SSRDisclaimers from "../components/SSRDisclaimers/SSRDisclaimers";

const SSRMob: FC<{ stepButtons: ReactNode }> = ({ stepButtons }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex w-full flex-col gap-3">
        <div className="flex flex-col gap-0.5">
          <div className="text-lg font-bold md:text-2xl">{t("Flights.details.steps.extraSelections")}</div>
          <div className="text-font-minimal text-xs font-semibold md:text-sm">{t("Flights.details.steps.extraSelectionsSubtitle")}</div>
        </div>
        <SSRSelection />
        <div className="flex flex-col gap-6 rounded-xl">
          <div className="border-border-minimal bg-background-default flex flex-col gap-5 rounded-md border-t p-3 pt-3 shadow-sm">
            <FlightSelection />
            <div className="flex flex-col gap-1">
              <div className="text-font-minimal text-xs font-medium uppercase tracking-wide">{t("Flights.details.ssr.assignTo")}</div>
              <PassengerSelection />
            </div>
          </div>
          <div className="bg-background-minimal rounded-md p-2">
            <SSROutlet />
          </div>
        </div>

        <SSRDisclaimers />
      </div>
      {stepButtons}
    </>
  );
};

export default SSRMob;
